// src/components/ShalomSection.jsx
import React from 'react';
// import { Link } from 'react-router-dom';
import { FaChurch } from 'react-icons/fa';

const ShalomSection = () => {
    return (
        <section className="bg-white py-16 px-6 md:px-12 rounded-3xl shadow-xl border-l-8 border-blue-600 animate-fade-in">
            <div className="max-w-4xl mx-auto text-center">

                {/* Judul Utama SHALOM */}
                <h2 className="text-5xl font-extrabold text-blue-900 flex items-center justify-center space-x-4 mb-8">
                    <FaChurch className="text-blue-600 text-6xl" />
                    <span className="tracking-wide">SHALOM!</span>
                </h2>

                {/* Kotak Teks - Bahasa Indonesia */}
                <div className="bg-blue-50 p-6 md:p-8 rounded-xl shadow-inner space-y-4">
                    <p className="text-gray-600 text-justify leading-relaxed text-base">
                        Majelis Jemaat GPIB "Kasih Karunia" Badung-Bali mengucapkan
                        <strong> SELAMAT DATANG </strong>Bagi saudara-saudari yang merupakan jemaat baru, pertama kali ingin beribadah,
                        ataupun memerlukan pelayanan khusus, dapat menghubungi <strong>KANTOR MAJELIS JEMAAT</strong> setiap jam kerja,
                        atau Presbiter yang sedang bertugas.
                    </p>
                </div>

                {/* Pembatas Elegan */}
                <hr className="my-8 border-t-2 border-gray-300" />

                {/* Kotak Teks - Bahasa Inggris */}
                <div className="bg-blue-50 p-6 md:p-8 rounded-xl shadow-inner space-y-4">
                    <p className="text-gray-600 text-justify leading-relaxed text-base italic">
                        The Congregational Council of GPIB <strong>"Kasih Karunia"</strong> Badung-Bali wishes <strong>WELCOME</strong> for those of you who are new members of the congregation,
                        want to follow sunday service for the first time, or if you need special services, prayer, or else,
                        you can contact our <strong>Congregational Council Office Church on the available work hour</strong>, or the Presbytery on duty.
                    </p>
                </div>
            </div>
        </section>
    );
};

export default ShalomSection;